import { useState, useEffect } from 'react';
import { addStopToFolder, deleteStop, getStopsByFolder } from '../utils/localStorage';

export const useStops = (folderId) => {
  const [stops, setStops] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const loadStops = () => {
    if (folderId) {
      const data = getStopsByFolder(folderId);
      setStops(data);
    }
  };

  useEffect(() => {
    loadStops();
  }, [folderId]);

  const addStop = (stopId, stopName, line) => {
    const newStop = addStopToFolder(folderId, stopId, stopName, line);
    setStops([...stops, newStop]);
    return newStop;
  };

  const removeStop = (stopId) => {
    deleteStop(stopId);
    setStops(stops.filter(s => s.id !== stopId));
  };

  const refreshStops = () => {
    loadStops();
  };

  return {
    stops,
    loading,
    error,
    addStop,
    removeStop,
    refreshStops
  };
};
